module.exports = __webpack_public_path__ + "static/home_01-972b21ebc690ff95f1d1e2d8cc3d0a54.webp";